import { ExcelColumn } from '../../../../../../generic/hooks/useExportToExcel'
import { IProductWithCounItem } from '../../../../../../modules/API/Products/models/productsWithCount'

export const excelColumnsByCalcMethod = (calcMethod: number): ExcelColumn<IProductWithCounItem>[] => {
  const baseColumns: ExcelColumn<IProductWithCounItem>[] = [
    { header: 'פריט', accessor: (item) => `${item.ProductDesc.trim()} ${item.VarietyDesc.trim()}` },
    { header: 'הזמנות לקוח אריזות', accessor: 'OrdersPacks' },
  ]

  switch (calcMethod) {
    case 3:
      return [
        ...baseColumns,
        { header: 'הזמנות לקוח משקל', accessor: 'OrdersWeight' },
        { header: 'הזמנות רכש אריזות', accessor: 'OrdersSupplyPacks' },
        { header: 'הזמנות רכש משקל', accessor: 'OrdersSupplyWeight' },
        { header: 'מלאי אריזות', accessor: 'MlaiPacks' },
        { header: 'מלאי משקל', accessor: 'MlaiWeight' },
        { header: 'חוסר משקל', accessor: 'MlaiCafuiWeight' },
        { header: 'יתרה משקל', accessor: 'ItraWeight' },
      ]
    case 2:
      return [
        ...baseColumns,
        { header: 'הזמנות לקוח משטחים', accessor: 'OrdersPallets' },
        { header: 'הזמנות רכש אריזות', accessor: 'OrdersSupplyPacks' },
        { header: 'הזמנות רכש משטחים', accessor: 'OrdersSupplyPallets' },
        { header: 'מלאי אריזות', accessor: 'MlaiPacks' },
        { header: 'מלאי משטחים', accessor: 'MlaiPallets' },
        { header: 'חוסר משטחים', accessor: 'MlaiCafuiPallets' },
        { header: 'יתרה משטחים', accessor: 'ItraPallets' },
      ]
    default:
      return [
        ...baseColumns,
        { header: 'הזמנות רכש אריזות', accessor: 'OrdersSupplyPacks' },
        { header: 'מלאי אריזות', accessor: 'MlaiPacks' },
        { header: 'חוסר אריזות', accessor: 'MlaiCafuiPacks' },
        { header: 'יתרה אריזות', accessor: 'ItraPacks' },
      ]
  }
}
